import { TileCacheSeedStrategy } from "../../../Features/MapComponents/TileCache/indexedDB/types";

/**
 * The default database name
 */
export const DEFAULT_DATABASE_NAME: string = "tile-cache-data";

/**
 * The default object store name of the database
 */
export const DEFAULT_OPERATION_OBJECT_STORE_NAME: string = "op-status";

/**
 * The default object store name of the database
 */
export const DEFAULT_TILE_OBJECT_STORE_NAME: string = "tiles";

/**
 * The default tile error/missing URL. 256x256 white PNG.
 */
export const DEFAULT_ERROR_TILE_URL: string = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAABlBMVEX///////9VfPVsAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAwElEQVRoge3SUQ7CIBAE0FlcE/7sDewRPAL1XP1Yb+wJVAq1TWS1Jn46LyEhYRigKUBEREREREREP9IYgGR5JgGGrm8TeViZSR7tOkJdQc0lN4A14AhrxtzMNw26bBcvoNBzvegF0jkte9X5JBm8htIxH5M7WhGi+fmxlAzovIppd13wjyiB01YgbQXsUyDvX1a8S+YfIc0fPFkTqO83fdb3r4G4HF1L0mvgcJMrxmm2u9uI47tbEhEREREREf2PB+hqEOJRdW2yAAAAAElFTkSuQmCC";

/**
 * The fallback version of your IndexedDB database
 */
export const DEFAULT_DATABASE_VERSION: number = 5;

/**
 * The default maximum age of a cached tile (one week)
 */
export const DEFAULT_REFETCH_AGE_DAYS: number = 7; 

//export const DEFAULT_SEED_STRATEGY_DAYS: TileCacheSeedStrategy = TileCacheSeedStrategy.All; //TODO: Switch to TileCacheSeedStrategy.OnlyMissingOrStale once testing of list is complete
export const DEFAULT_SEED_STRATEGY_DAYS: TileCacheSeedStrategy = TileCacheSeedStrategy.OnlyMissingOrStale;

export const DEFAULT_OPERATION_EVENT_CHANNEL_NAME: string = "tile-op-status";

export const DEFAULT_OPERATION_HISTORY_MAX_AGE_DAYS: number = 30;

export const DEFAULT_UI_TITLE_OP_INPROGRESS: string = "Map Tile Download";
export const DEFAULT_UI_TITLE_OP_FAILED: string = "Map Tile Download Failed";
export const DEFAULT_UI_TITLE_OP_SUCCESS: string = "Map Tile Download Complete";